

export default {
  state: {
    detentions: [],
    acumDetentions: 0
  },

  mutations: {

    updateDetentions(state, detentions) {
      state.detentions = detentions
    },
    updateAcumDetentions(state,acumDetentions) {
      state.acumDetentions = acumDetentions
    }
  },

  actions: {
    async getDetentions({ commit }, payload) {
      try {
        const response = await this._vm.$http.get(`detentions?devid=${payload.devid}&start=${payload.start}&end=${payload.end}`)

        let normalizedResponse = response.data.detentions

        response.data.detentions.map((val, index) => {
          normalizedResponse[index].start = val.start + 'Z'
          normalizedResponse[index].end = val.end + 'Z'
        })

        commit('updateDetentions', normalizedResponse)

      } catch (error) {
        console.log(error)
      }
    },
    async getAcumDetentions({ commit }, payload) {
      try {
        const response = await this._vm.$http.get(`detentions?devid=${payload.devid}&start=${payload.start}&end=${payload.end}`)
        //detenciones fuera de rango
        const dets = response.data.detentions
        let first, last, removeStart, removeEnd
        first = last = removeStart = removeEnd = 0

        if(dets.length > 0 && dets[0]) {
          first = new Date(dets[0].start).getTime()/1000
        }
        if(dets.length > 0 && dets[dets.length-1]) {
          last = new Date(dets[dets.length-1].end).getTime()/1000
        }

        if(first && first < payload.start) {
          removeStart = payload.start - first
        }
        if(last && last > payload.end) {
          removeEnd = last - payload.end
        }
        //
        let acumDetentions = dets.reduce((acum, val) => {
          return acum + val.diff
        }, 0)

        acumDetentions = acumDetentions - removeStart - removeEnd

        commit('updateAcumDetentions', acumDetentions)
      } catch (error) {
        console.log(error)
      }
    }
  },

  getters: {
    detentions(state) {
      return state.detentions
    },
    acumDetentions(state) {
      return state.acumDetentions
    }
  }
}
